// Environment-based configuration
const ENV_CONFIG = {
  development: {
    ISI_API_URL: "https://isi-data-dev.isilive.ca/",
    ISI_RTMP_INPUT_DOMAIN: "stream-dev.isilive.ca",
    ISI_PLAYER_DOMAIN: "video-dev.isilive.ca",
    SP2_PLAYER_DOMAIN: "player2.isilive.ca",
    ISI_HLS_URL: "https://isi-data-dev.isilive.ca/",
    DISPATCHER_URL: "https://encode-dispatcher-a-dev.isilive.ca/",
  },
  testing: {
    ISI_API_URL: "https://sp2api2.isilive.ca/",
    ISI_RTMP_INPUT_DOMAIN: "stream2.isilive.ca",
    ISI_PLAYER_DOMAIN: "video2.isilive.ca",
    SP2_PLAYER_DOMAIN: "player2.isilive.ca",
    ISI_HLS_URL: "https://sp2hls2.isilive.ca/",
    DISPATCHER_URL: "https://encode-dispatcher-a2.isilive.ca/",
  },
  production: {
    ISI_API_URL: "https://sp2api.isilive.ca/",
    ISI_RTMP_INPUT_DOMAIN: "stream.isilive.ca",
    ISI_PLAYER_DOMAIN: "video.isilive.ca",
    SP2_PLAYER_DOMAIN: "player.isilive.ca",
    ISI_HLS_URL: "https://sp2hls.isilive.ca/",
    DISPATCHER_URL: "https://encode-dispatcher-a.isilive.ca/",
  },
};

// Determine environment based on hostname
function getEnvironment() {
  const hostname = window.location.hostname;

  if (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname.includes("admin-dev.isilive.ca")
  ) {
    return "development";
  } else if (hostname.includes("admin2.isilive.ca")) {
    return "testing";
  } else {
    return "production";
  }
}

const currentEnv = getEnvironment();
const config = ENV_CONFIG[currentEnv] || ENV_CONFIG.production;

export const ISI_API_URL = config.ISI_API_URL;
export const ISI_RTMP_INPUT_DOMAIN = config.ISI_RTMP_INPUT_DOMAIN;
export const ISI_PLAYER_DOMAIN = config.ISI_PLAYER_DOMAIN;
export const SP2_PLAYER_DOMAIN = config.SP2_PLAYER_DOMAIN;
export const ISI_HLS_URL = config.ISI_HLS_URL;
//export const DISPATCHER_URL = config.DISPATCHER_URL;

// Export environment for debugging
export const CURRENT_ENV = currentEnv;

// prod asuigtcfbv.us-east-1.awsapprunner.com
// dev sidnipn4iu.us-east-1.awsapprunner.com

//d-0odbhelhma.execute-api.ca-central-1.amazonaws.com
